export default class FaqController {
  constructor($sce) {
    'ngInject';

    this.questions = this.rawQuestions().map((rawQuestion) => {
      rawQuestion.answer = $sce.trustAsHtml(rawQuestion.answer);
      return rawQuestion;
    })
  }

  rawQuestions() {
    return this.questions = [
      {
        question: 'What is Pingsta?',
        answer: `<p>Pingsta is a knowledge-sharing platform that enables Internet network engineers to earn money
                 by sharing their expertise to solve network issues, which in turn helps to make the Internet work better and safer.</p>`
      },
      {
        question: 'What are the benefits of Pingsta membership?',
        answer: `<p>
                    By joining Pingsta, you:
                    <ul>
                      <li>Become a part of an elite exclusive community of network & security experts worldwide;</li>
                      <li>Share your expertise, which puts an end to solving problems in silos, and thus enhances Internet availability and security;</li>
                      <li>Monetize your knowledge and earn US$100 per support task and US$100 per hour for consulting tasks, work at-will, at anytime, from anywhere;</li>
                      <li>Participate in discussions that will impact the future of the internet;</li>
                      <li>Empower the world.</li>
                    </ul>
                 </p>`
      },
      {
        question: 'How do I join Pingsta?',
        answer: `Request an invitation using the ‘Request Invite’ button above.`
      },
      {
        question: 'Will my information be secure with Pingsta?',
        answer: `Yes, we take your privacy very seriously. Pingsta will never sell nor distribute your personal information under any circumstances.`
      },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/faq/faq.controller.js